
import axios from 'axios';
import Cookies from "js-cookie";
import ELocalStorageKeys from 'types/LocalStorageKey';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/',
    // timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to always get the latest token
axiosInstance.interceptors.request.use((config) => {
    const token = Cookies.get(ELocalStorageKeys.AccessToken);
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        if (config.headers && config.headers.Authorization) {
            delete config.headers.Authorization;
        }
    }
    return config;
});

export default axiosInstance;